import { Routes } from '@angular/router';

import { routeData } from '@frontend/vanilla/core';

import { ClientConfigActivateGuard } from './client-configs/guards/client-config-activate.guard';
import { PromoConfigActivateGuard } from './client-configs/guards/promo-config-activate.guard';

export const ENGAGEMENT_ROUTES: Routes = [
    {
        path: 'bspin',
        loadChildren: () => import(/* webpackChunkName: "bspin-module" */ './bspin/bspin.routes').then((m) => m.BspinRoutes),
        data: routeData({ allowAnonymous: true, allowAuthorized: true }),
    },
    {
        path: 'prizewheel',
        loadChildren: () => import(/* webpackChunkName: "bspin-module" */ './bspin/bspin.routes').then((m) => m.BspinRoutes),
        data: routeData({ allowAnonymous: true, allowAuthorized: true }),
    },
    {
        path: 'pickabox',
        loadChildren: () => import(/* webpackChunkName: "pick-a-box-module" */ './pick-a-box/pick-the-box.routes').then((m) => m.PickTheBoxroutes),
        data: routeData({ allowAnonymous: true, allowAuthorized: true }),
    },
    {
        path: 'servererror',
        loadChildren: () => import(/* webpackChunkName: "server-error-module" */ '@frontend/vanilla/features/server-error').then((m) => m.ROUTES),
        data: routeData({ allowAnonymous: true }),
    },
    {
        path: '**',
        loadComponent: () =>
            import(/* webpackChunkName: "promo-content-loader-module" */ './promo-content-loader/promo-content-loader.component').then(
                (m) => m.PromoContentLoaderComponent,
            ),
        canActivate: [PromoConfigActivateGuard, ClientConfigActivateGuard],
        data: routeData({ allowAnonymous: true, allowAuthorized: true }),
    },
];
